<app-bottom-sheet #sheet ariaLabel="بیانیه ریسک">
	<ng-template #body>
		<div class="flex flex-col gap-3" data-cy="portfolio-risk-statement-content">
			<h3 class="flex items-center justify-center gap-1 text-sm font-bold text-gray-900 pt-3">
				<ui-icon width="20" height="20" iconName="alert" aria-hidden="true" />
				بیانیه ریسک
			</h3>
			<span class="text-3.25 text-justify text-gray-900" data-cy="portfolio-risk-statement-text">
				قیمت سربه‌سر و سود زیان نمادها جهت تسهیل محاسبات کاربر محاسبه شده است و مبنای تصمیم‌گیری برای کاربر
				نیست. مسئولیت کنترل صحت محاسبات بر عهده کاربر است و شرکت کارگزاری مفید مسئولیت در این خصوص ندارد.
			</span>
		</div>
	</ng-template>

	<ng-template #footer>
		<div class="flex w-full py-4" data-cy="portfolio-risk-statement-actions">
			<ui-button
				type="button"
				class="w-full"
				size="lg"
				extraButtonClasses="w-full"
				label="متوجه شدم"
				data-cy="portfolio-risk-statement-acknowledge"
				(clicked)="onAcknowledgeClick()" />
		</div>
	</ng-template>
</app-bottom-sheet>
